import {
  Text,
  TextField,
  Button,
  Stack,
} from "@towersystems/roam-common-native";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Spacings, View } from "react-native-ui-lib";
import { InvoiceArrivalItemFormValues } from "../../types";
import { Ionicons } from "@expo/vector-icons";

export interface SerialNumbersInputProps {
  onChange: (value: string[]) => void;
  value: string[];
}

const InternalSerialNumbersInput = ({
  onChange,
  value = [],
}: SerialNumbersInputProps) => {
  const [serialNumbers, setSerialNumbers] = React.useState<string[]>(value);

  const handleOnChange = React.useCallback(
    (value: string, index: number) => {
      const newSerialNumbers = [...serialNumbers];
      newSerialNumbers[index] = value;
      setSerialNumbers(newSerialNumbers);
      onChange(newSerialNumbers);
    },
    [serialNumbers]
  );

  const handleOnAddMore = React.useCallback(() => {
    const newSerialNumbers = [...serialNumbers, ""];
    setSerialNumbers(newSerialNumbers);
    onChange(newSerialNumbers);
  }, [serialNumbers]);

  const handleOnRemove = React.useCallback(
    (index: number) => {
      const newSerialNumbers = [...serialNumbers];
      newSerialNumbers.splice(index, 1);
      setSerialNumbers(newSerialNumbers);
      onChange(newSerialNumbers);
    },
    [serialNumbers]
  );

  const textInputsMarkup = React.useMemo(() => {
    return (
      <Stack spacing={Spacings.s5} vertical>
        {serialNumbers.map((value, index) => {
          return (
            <TextField
              value={value}
              onChangeText={(value) => handleOnChange(value, index)}
              placeholder="Serial Number"
              trailingAccessory={
                <Button size="compact" onPress={() => handleOnRemove(index)}>
                  <Text color="destructive">
                    <Ionicons name="remove" size={24} />
                  </Text>
                </Button>
              }
            />
          );
        })}
      </Stack>
    );
  }, [serialNumbers]);

  const addMoreButtonMarkup = (
    <Button isAction onPress={handleOnAddMore} label="Add new"></Button>
  );

  return (
    <View>
      <Stack spacing={Spacings.s5} vertical>
        {textInputsMarkup}
        {addMoreButtonMarkup}
      </Stack>
    </View>
  );
};

export const SerialNumbersInput = () => {
  const { control } = useFormContext<InvoiceArrivalItemFormValues>();
  return (
    <Controller
      name="serialNumbers"
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <InternalSerialNumbersInput value={value} onChange={onChange} />
      )}
    />
  );
};
